import { Info } from "lucide-react"
import { useState, useEffect } from "react"
import { Form } from "react-bootstrap"
import { Link } from "react-router-dom"
import ButtonWithTooltip from "../buttons/ButtonWithTooltip"

const SignupSelectInput = (props) => {
  const {
    label,
    name,
    feedback,
    validTest,
    setValid,
    isValid,
    setData,
    blurAll,
    existingAccountType,
    ...inputProps
  } = props

  const [isTouched, setIsTouched] = useState(false)

  const handleOnChange = (e) => {
    setData(e.target.value)
    setValid(name, validTest(e.target.value))
  }

  const handleOnBlur = (e) => {
    setIsTouched(true)
    setValid(name, validTest(e.target.value))
  }

  useEffect(() => {
    if (blurAll) {
      setIsTouched(true)
    }
  }, [blurAll])

  return (
    <Form.Group className="mb-2" controlId={name}>
      <Form.Label className="mt-2 fw-semibold text-muted">
        {label}
        <ButtonWithTooltip text="Click to view account types">
          <Link
            to={"https://www.gymnasticbritannia.co.uk/prices"}
            className="ms-2"
            aria-label="More information"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Info size={16} />
          </Link>
        </ButtonWithTooltip>
      </Form.Label>
      <Form.Select
        onBlur={handleOnBlur}
        isInvalid={!isValid && isTouched}
        onChange={handleOnChange}
        value={existingAccountType || undefined}
        disabled={!!existingAccountType}
        {...inputProps}
      >
        <option value="">Select Account Type</option>
        <option value="gymnast">Gymnast</option>
        <option value="assistant">Assistant Coach</option>
        <option value="coach">Coach</option>
        <option value="director">Director</option>
      </Form.Select>
      <Form.Control.Feedback type="invalid" className="fw-semibold">
        <i>{feedback}</i>
      </Form.Control.Feedback>
    </Form.Group>
  )
}
export default SignupSelectInput